const CONCURRENCE_ERROR = 409;
const ARTICLE_HAS_BEEN_PUBLISHED = 403;
const ARTICLE_WAS_RETURNED_TO_DRAFT = 423;

export { ARTICLE_HAS_BEEN_PUBLISHED, ARTICLE_WAS_RETURNED_TO_DRAFT, CONCURRENCE_ERROR };
